import styled from 'styled-components';

export const CardWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.gray8};
  border: 1px solid ${({ theme }) => theme.colors.gray6};
  border-radius: 4px;
  padding: 0.75rem 1rem;
  margin-top: 0.5rem;
`;

export const CardName = styled.span`
  display: block;
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #192d38;
`;

export const CardAddress = styled.span`
  display: block;
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #414e55;
`;
